import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import VendorServices from "services/VendorServices";
import { notifyError, notifySuccess } from "utils/toast";

const useVendorSubmit = (id, onModalOpen) => {
  const {
    isDrawerOpen,
    closeDrawer,
    setIsUpdate,
    selectedVendorValue,
    setSelectedVendorValue,
    setSelectedCompanyValue,
    selectedCompanyValue,
    fleetContent,
    setFleetContent,
    companyContent,
    setCompanyContent,
  } = useContext(SidebarContext);
  const [selectedYear, setSelectedYear] = useState(null);
  const [step, setStep] = useState(1);
  const [idProofUrl, setIDProofUrl] = useState("");
  const [panUrl, setPanUrl] = useState("");
  const [rcUrl, setRcUrl] = useState("");
  const [gstUrl, setGstUrl] = useState("");
  const [checkLeafUrl, setCheckLeafUrl] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [patternProof, setPatternProof] = useState(/^\d{12}$/);
  const [palaceholderProof, setPalaceholderProof] = useState("xxxxxxxx4345");
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedCountryId, setSelectedCountryId] = useState(null);
  const [selectedCountryCode, setSelectedCountrycode] = useState("");
  const [selectedRole, setselectedRole] = useState("");
  const [selectedProof, setselectedProof] = useState("");
  const [selectedCities, setSelectedCities] = useState([]);
  const [selectedRadioValueGender, setSelectedRadioValueGender] = useState("");
  const [selectedFleetTypeValue, setSelectedFleetTypeValue] = useState("");
  const [selectedServiceState, setSelectedServiceState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFranchise, setSelectedFranchise] = useState(null);
  const [franchiseError, setFranchiseError] = useState("");
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    trigger,
    formState: { errors },
  } = useForm();
  const handleServiceChange = (value) => {
    setSelectedServices((prev) => {
      const newServices = prev.includes(value)
        ? prev.filter((v) => v !== value)
        : [...prev, value];
      setValue("service_type", newServices); // Sync form state
      return newServices;
    });
  };
  const handleYearChange = (date) => {
    setSelectedYear(date);
  };

  const handleCountryChange = (country_code, country_id) => {
    setSelectedCountryId(country_id);
    setSelectedCountrycode(country_code);
  };
  const handleStateChange = (state_id) => {
    setSelectedState(state_id);
  };
  const handleCityChange = (city_id) => {
    setSelectedCity(city_id);
  };
  const handlefranchiseChange = (franchise_id) => {
    setSelectedFranchise(franchise_id);
    setFranchiseError("");
    // setValue("franchise", franchise_id);
  };
  const handleChangeVendorType = (value) => {
    setSelectedVendorValue(value);

    if (selectedCompanyValue === "Company") {
      setCompanyContent(1);
    } else if (selectedCompanyValue === "Non-Company") {
      setCompanyContent(0);
    } else {
      setCompanyContent(0);
      setFleetContent(0);
    }
  };
  const handleChangeCompany = (value) => {
    setSelectedCompanyValue(value);
    if (value === "Company") {
      setCompanyContent(1);
    } else {
      setCompanyContent(0);
    }
  };
  const handleChangeRadioGender = (value) => {
    setSelectedRadioValueGender(value);
  };
  const handleChangeFleetType = (value) => {
    setSelectedFleetTypeValue(value);
  };

  const handleChangeProof = (value) => {
    setselectedProof(value);
    if (value === "1") {
      setPatternProof(/^\d{12}$/);
      setPalaceholderProof("xxxx xxxx 4345");
    } else if (value === "2") {
      setPatternProof(/^[A-Z]{3}[0-9]{7}$/);
      setPalaceholderProof("XGN3002623");
    } else if (value === "3") {
      setPatternProof(/^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/);
      setPalaceholderProof("A1234567");
    }
  };
  const validateImage = () => {
    if (!idProofUrl && step === 3) {
      errors.idProofUrl = {
        type: "required",
        message: "ID Proof is required!",
      };
    } else {
      delete errors.idProofUrl;
    }
    if (!panUrl && step === 4) {
      errors.panUrl = { type: "required", message: "PAN Card is required!" };
    } else {
      delete errors.panUrl;
    }
    if (!checkLeafUrl && step === 5) {
      errors.checkLeafUrl = {
        type: "required",
        message: "Check Leaf is required!",
      };
    } else {
      delete errors.checkLeafUrl;
    }
  };
  const handleNextStep = async () => {
    await Promise.all([validateForm(), validateImage()]);
    if (step === 1 && !selectedFranchise) {
      setFranchiseError("Franchise is required!");
      return;
    }
    if (Object.keys(errors).length === 0) {
      if (step !== 5) {
        setStep(step + 1);
      }
    }
  };
  const handlePreviousStep = async () => {
    await Promise.all([validateForm(), validateImage()]);

    setStep(step - 1);
  };
  const goToStep = async (stepNumber) => {
    await Promise.all([validateForm(), validateImage()]);
    if (Object.keys(errors).length === 0) {
      setStep(stepNumber);
    }
  };
  const validateForm = async () => {
    await trigger();

    return Object.keys(errors).length;
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const stateIds = selectedServiceState
        .map((state) => {
          if (typeof state === "string") {
            return parseInt(state, 10);
          }
          if (typeof state === "object" && state.value) {
            return parseInt(state.value, 10);
          }
          return null;
        })
        .filter(Boolean);

      data.proof_image = idProofUrl;
      data.pan_image = panUrl;
      data.rc_image = rcUrl;
      if (gstUrl) {
        data.gst_image = gstUrl;
      } else {
        data.gst_image = null;
      }
      data.check_leaflet_image = checkLeafUrl;
      data.state = selectedState;
      data.franchise_partner_id = selectedFranchise;
      data.city = selectedCity;
      data.proof_type = selectedProof;
      data.service_city = selectedCities;
      data.service_state = stateIds;
      data.al_call_prefix = data.call_prefix = selectedCountryCode;
      data.al_contact_no = data.al_contact_no ? data.al_contact_no : "";
      data.service_type = selectedServices;
      // data.company_name=(data.company_type==='Company'? data.company_name:'');
      // data.address=(data.company_type==='Company'? data.address:'');
      // data.pincode=(data.company_type==='Company'? data.pincode:'');
      //return false;
      setIsSubmitting(true);

      if (id) {
        const res = await VendorServices.updateVendor(id, data);
        setIsUpdate(true);
        setIsSubmitting(false);
        closeDrawer();
        notifySuccess(res.message);
      } else {
        const res = await VendorServices.addVendor(data);
        setIsUpdate(true);
        setIsSubmitting(false);
        closeDrawer();
        notifySuccess(res.message);
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err.message);
      setIsSubmitting(false);
      // closeDrawer();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          const res = await VendorServices.getVendorById(id);
          if (res) {
            var Response = res.data;
            setValue("company_name", Response.company_name);
            setSelectedCompanyValue(Response.company_type);
            setselectedProof(
              Response.proof_type !== 0 ? Response.proof_type : "",
            );
            setCompanyContent(Response.pincode !== "" ? 1 : 0);
            setSelectedCountrycode(Response.call_prefix);
            setValue("authorized_person", Response.authorized_person);
            setValue("email", Response.email);
            setValue("contact_no", Response.contact_no);
            setSelectedServiceState(Response.service_state);
            setSelectedCities(Response.service_city.map(Number));
            setValue("al_contact_no", Response.al_contact_no);
            setValue("password", Response.password);
            setPanUrl(Response.pan_image);
            setValue("pan_no", Response.pan_no);
            setValue("refered_by", Response.refered_by);
            setSelectedCity(Response.city);
            setSelectedFranchise(Response.franchise_partner_id);
            setSelectedState(Response.state);
            setSelectedCountryId(Response.country);
            setSelectedVendorValue(Response.vendor_type);
            setSelectedFleetTypeValue(Response.fleet_type);
            setSelectedRadioValueGender(Response.gender);
            setValue("address", Response.address);
            setValue("pincode", Response.pincode);
            setValue("name_in_proof", Response.name_in_proof);
            setValue("id_proof", Response.id_proof);
            setValue("account_no", Response.account_no);
            setValue("beneficiary_name", Response.beneficiary_name);
            setValue("ifsc_code", Response.ifsc_code);
            setValue("service_state", Response.service_state);
            setGstUrl(Response.gst_image);
            setRcUrl(Response.rc_image);
            setCheckLeafUrl(Response.check_leaflet_image);
            setIDProofUrl(Response.proof_image);
            setValue("gst", Response.gst);
            setSelectedServices(Response.service_type || []);
            setValue("service_type", Response.service_type || []);
          }
        } catch (err) {
          notifyError(err ? err?.response?.data?.message : err.message);
        }
      })();
    }
    if (!id) {
      clearErrors();

      setStep(1);
      setSelectedCompanyValue("Company");
      setSelectedCity(null);
      setSelectedState(null);
      setSelectedServiceState([]);
      setSelectedCities([]);
      setValue("authorized_person");
      setSelectedFranchise(null);
      setFranchiseError("");
      setValue("email");
      setValue("call_prefix");
      setValue("contact_no");
      setValue("al_call_prefix");
      setValue("al_contact_no");
      setValue("company_name");
      setValue("address");
      setValue("password");
      setValue("pincode");
      setValue("proof_type");
      setValue("name_in_proof");
      setValue("service_state");
      setValue("id_proof");
      setValue("refered_by");
      setIDProofUrl("");
      setValue("pan_no");
      setPanUrl("");
      setValue("gst_no");
      setGstUrl("");
      setRcUrl("");
      setValue("account_no");
      setValue("beneficiary_name");
      setValue("ifsc_code");
      setCheckLeafUrl("");
      setSelectedServices([]); // Reset selectedServices
      setValue("service_type", []); // Reset form state
    }
    // eslint-disable-next-line
  }, [id, isDrawerOpen, setValue, clearErrors]);

  return {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    errors,
    handleNextStep,
    step,
    setStep,
    handlePreviousStep,
    goToStep,
    setSelectedRadioValueGender,
    setSelectedCompanyValue,
    setSelectedCity,
    setSelectedFranchise,
    setSelectedState,
    setSelectedCountryId,
    setSelectedVendorValue,
    setSelectedFleetTypeValue,
    setSelectedCountrycode,
    setCheckLeafUrl,
    setPanUrl,
    setIDProofUrl,
    setGstUrl,
    selectedFranchise,
    idProofUrl,
    panUrl,
    gstUrl,
    checkLeafUrl,
    isSubmitting,
    selectedCompanyValue,
    selectedCity,
    selectedState,
    selectedCountryId,
    selectedProof,
    selectedRole,
    selectedCountryCode,
    selectedVendorValue,
    selectedFleetTypeValue,
    selectedRadioValueGender,

    selectedServices,
    setSelectedServices,
    handleChangeCompany,
    handleChangeFleetType,
    handleChangeProof,
    handleChangeRadioGender,
    handleChangeVendorType,
    handleServiceChange,
    handleCityChange,
    handleCountryChange,
    handleStateChange,
    handlefranchiseChange,
    fleetContent,
    companyContent,
    setselectedRole,
    patternProof,
    palaceholderProof,
    handleYearChange,
    selectedYear,
    rcUrl,
    setRcUrl,
    selectedCities,
    setSelectedCities,
    selectedServiceState,
    setSelectedServiceState,
    loading,
    setLoading,
    franchiseError,
  };
};

export default useVendorSubmit;
